import { axiosClient } from '@nx-frontend/shared/api';
import { getPortalsUsageByOrgId } from '@nx-frontend/shared/api/webnotes';
import { generalEnv } from '@nx-frontend/shared/env';
import { Workspace } from '@nx-frontend/shared/types';
import { CreateWorkspaceParams } from '@nx-frontend/shared/types';
import { CreateWorkspaceOptions } from '@nx-frontend/shared/types';

export async function createWorkspace(
  { orgId, title, skipLimits }: CreateWorkspaceParams,
  options: CreateWorkspaceOptions
): Promise<Workspace | null> {
  const { userId } = options;
  let workspace: Workspace | null = null;

  try {
    let response;
    if (skipLimits) {
      const portalsUsage = await getPortalsUsageByOrgId({ orgId }, { userId });
      const canAddNewPortal = Boolean(portalsUsage && portalsUsage.active < portalsUsage.limit);

      if (canAddNewPortal) {
        response = await axiosClient.post<Workspace>(
          `${generalEnv.workspaceServiceUrl}/v1/workspaces?skipLimits=true`,
          {
            orgId,
            title,
          },
          {
            headers: {
              Authorization: `internal ${userId}:auto`,
            },
            secret: generalEnv.superSecret,
          }
        );
      } else {
        throw new Error('Portals limit error');
      }
    } else {
      response = await axiosClient.post<Workspace>(
        `${generalEnv.workspaceServiceUrl}/v1/workspaces?skipLimits=false&waitMember=true`,
        {
          orgId,
          title,
        },
        {
          headers: {
            Authorization: `internal ${userId}:auto`,
          },
        }
      );
    }
    workspace = response.data;
  } catch (err) {
    if (!skipLimits) {
      throw err;
    }
  }

  return workspace;
}
